import { useEffect, useRef } from 'react'
import useWindowSize from '../WebcamStreamCapture/hooks/useWindowSize'
import useAudioSpectrum from './useAudioSpectrum'

const Visualizer = () => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const audioContextRef = useRef<AudioContext | null>(null)
  const animationRef = useRef<number | null>(null)
  const analyserRef = useRef<AnalyserNode | null>(null)

  const size = useWindowSize()

  const { drawSpectrum } = useAudioSpectrum({
    canvasRef,
    analyserRef,
    animationRef
  })

  useEffect(() => {
    navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
      startVisualizer(stream)
    })

    return () => {
      stopVisualizer()
      audioContextRef.current?.close()
    }
  }, [])

  const startVisualizer = (stream: MediaStream) => {
    const audioContext = new AudioContext()
    audioContextRef.current = audioContext

    const source = audioContext.createMediaStreamSource(stream)
    const analyser = audioContext.createAnalyser()
    analyser.fftSize = 256
    source.connect(analyser)
    analyserRef.current = analyser

    drawSpectrum()
  }

  const stopVisualizer = () => {
    if (animationRef.current !== null) {
      cancelAnimationFrame(animationRef.current)
      animationRef.current = null
    }
  }

  return (
    <canvas
      ref={canvasRef}
      width={size.width}
      height={Math.max(150, (size.height || 0) - 310)}
      style={{ width: '100%', flex: 1, display: 'block' }}
    />
  )
}

export default Visualizer
